import { UserSubmission, UserProfile } from '../types/admin';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const getUserSubmissions = async (token: string): Promise<UserSubmission[]> => {
	const response = await fetch(`${API_BASE_URL}/my-reports`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		throw new Error('Neuspešno dohvatanje korisničkih prijava');
	}

	const data = await response.json();

	if (!data.success) {
		throw new Error(data.message || 'Neuspešno dohvatanje korisničkih prijava');
	}

	// Transform API response to match UI expectations
	return data.reports.map((report: any) => ({
		...report,
		type: 'survey' as const,
		status: 'processed' as const, // Default status, can be enhanced based on API
		riskLevel: report.riskScore >= 0.7 ? 'high' : report.riskScore >= 0.4 ? 'medium' : 'low',
		title: `Prijava ${new Date(report.submittedAt).toLocaleDateString('sr-RS')}`,
		description: `Nivo rizika: ${(report.riskScore * 100).toFixed(1)}%`,
	}));
};

export const getSubmissionDetails = async (token: string, submissionId: string): Promise<any> => {
	const response = await fetch(`${API_BASE_URL}/user/submissions/${submissionId}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		throw new Error('Neuspešno dohvatanje detalja prijave');
	}

	return response.json();
};

export const updateUserProfile = async (token: string, profile: UserProfile): Promise<any> => {
	const response = await fetch(`${API_BASE_URL}/user/profile`, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(profile),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Neuspešno ažuriranje profila');
	}

	return response.json();
};

export interface PasswordChangeRequest {
	currentPassword: string;
	newPassword: string;
}

export const changeUserPassword = async (token: string, passwordData: PasswordChangeRequest): Promise<any> => {
	const response = await fetch(`${API_BASE_URL}/user/password`, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(passwordData),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Neuspešna promena lozinke');
	}

	return response.json();
};
